module.exports = __webpack_public_path__ + "static/media/greenPants.99ddaf19.jpg";